import { eColumnConfigKeys } from "./enum";

export const ColumnConfigManager = {
    saveConfig: (key: eColumnConfigKeys, columns: any[]) => {
      localStorage.setItem(key, JSON.stringify(columns));
    },
    loadConfig: (key: eColumnConfigKeys, defaultColumns: any[]) => {
      const savedConfig = localStorage.getItem(key);
      return savedConfig ? JSON.parse(savedConfig) : defaultColumns;
    },
    resetConfig: (key: eColumnConfigKeys) => {
      localStorage.removeItem(key);
    },
    clearAll: () => {
      localStorage.clear();
    },
  };
  